import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Empty from 'antd/es/empty';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import FileBox from './file-box';
import { DisplayMoreText } from './styles';
import { ApplicationFilesSidebarBlockContainer, ApplicationFilesSidebarBlockCtas, ApplicationFilesSidebarBlockCtas2, } from './styles';
const MAX_FILES = 5;
const ApplicationFilesSidebarBlock = ({ files, emptyText, handleDownload, }) => {
    const [expanded, setExpanded] = useState(false);
    const theme = useTheme();
    const { t } = useTranslations();
    if (!files || files.length === 0) {
        return (_jsx(ApplicationFilesSidebarBlockContainer, { children: _jsx(Empty, { description: _jsx(Typography, { elementTheme: "subtitle2", color: theme.colors.grey_2, children: emptyText }) }) }));
    }
    const staticFiles = files.slice(0, MAX_FILES);
    const extraFiles = files.slice(MAX_FILES);
    const hiddenCount = files.length - MAX_FILES;
    return (_jsxs(ApplicationFilesSidebarBlockCtas, { children: [staticFiles.map((file) => (_jsx(FileBox, { assetId: file.assetId, displayName: file.displayName, extension: file.extension, createdAt: file.createdAt, fileSize: file.fileSize, Icon: file.Icon, handleDownload: handleDownload }, file.assetId))), expanded && (_jsx(ApplicationFilesSidebarBlockCtas2, { children: extraFiles.map((file) => (_jsx(FileBox, { assetId: file.assetId, displayName: file.displayName, extension: file.extension, createdAt: file.createdAt, fileSize: file.fileSize, Icon: file.Icon, handleDownload: handleDownload }, file.assetId))) })), files.length > MAX_FILES && (_jsx(DisplayMoreText, { elementTheme: "body2", color: theme.colors.purple_2, onClick: () => setExpanded((prev) => !prev), children: expanded
                    ? t('application_single|displayLess')
                    : hiddenCount > 1
                        ? t('application_single|displayMoreFiles', { hiddenCount })
                        : t('application_single|display1MoreFile') }))] }));
};
export default ApplicationFilesSidebarBlock;
